export function parseTrackingString(text: string): string {
  return text
    ? text
        .toLowerCase()
        .replace(/\&/g, "and")
        .replace(/[^a-z\-/ ]/gi, "")
        .replace(/\s*\-\s*/g, "-") // remove whitespace before/after -
        .replace(/\s*\/\s*/g, "-") // replace / incl. whitespace before/after
        .replace(/\s+/g, "-") // replace whitespaces with -
    : "";
}

export function sanitizeSensitiveData(searchTerm: string = ""): string {
  if (!searchTerm) return searchTerm;

  searchTerm = searchTerm.replace(
    /(((\+41|0041)(0?)(\s?)(\-?))|(0))(\d{2})(\s?)(\-?)(\d{3})(\s?)(\-?)(\d{2})(\s?)(\-?)(\d{2})/g,
    "[phone-number]",
  );
  // Close enough; goal is to keep information that an email was entered for statistical purposes,
  // not to catch every possible email address
  searchTerm = searchTerm.replace(
    /[a-zA-Z\._+-]+@[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}/g,
    "[e-mail]",
  );

  return searchTerm;
}

export function sanitizeTrackingApps(trackingApps: Record<string, any> = {}) {
  const { search } = trackingApps;

  if (search && search.term) {
    search.term = sanitizeSensitiveData(search.term);
  }

  return trackingApps;
}
